import { TabRouteEnum } from './components/model/tab.enum';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AzureProfileAdminGuard } from '../guards/azure-profile-admin.guard';
import { AzureProfileGuard } from '../guards/azure-profile.guard';
import { StationSettingsComponent } from './components/settings-station/station-settings.component';
import { StationManagementComponent } from './station-management.component';
import { CustomSourceComponent } from './components/custom-source/custom-source.component';

const routes: Routes = [
  {
    path: '',
    component: StationManagementComponent,
    canActivate: [MsalGuard, AzureProfileGuard, AzureProfileAdminGuard],
    children: [
      {
        path: `${TabRouteEnum.Station}`,
        component: StationSettingsComponent,
        data: { title: 'Stations' },
      },
      {
        path: `${TabRouteEnum.Source}`,
        component: CustomSourceComponent,
        data: { title: 'Sources' },
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StationManagementRoutingModule { }